/**
 * Algunos artículos generados por IA se guardan en una sola línea: los
 * marcadores Markdown (##, ###) quedan dentro del texto y react-markdown los
 * muestra como texto plano. Esta función reconstruye los saltos de línea para
 * que encabezados, párrafos y listas se rendericen correctamente.
 * El contenido ya correcto (con saltos de línea) se devuelve sin cambios.
 */
export function normalizeMarkdown(raw) {
  if (!raw || typeof raw !== 'string') return raw || '';
  if (raw.includes('\n')) return raw;
  if (!/#{2,4}\s/.test(raw)) return raw;

  // Cada encabezado en su propia línea, y luego se procesa bloque a bloque.
  const blocks = raw
    .replace(/(#{2,4}\s+)/g, '\n\n$1')
    .trim()
    .split(/\n{2,}/)
    .map((s) => s.trim())
    .filter(Boolean);

  const out = [];
  for (const block of blocks) {
    const m = block.match(/^(#{2,4})\s+([\s\S]*)$/);
    if (!m) {
      out.push(block, '');
      continue;
    }

    const level = m[1];
    const rest = m[2].trim();

    // El texto del encabezado y el párrafo siguiente quedaron fusionados:
    // se separan en el primer cierre de frase ("." o ":") del encabezado.
    let heading = rest;
    let body = '';
    const numbered = rest.match(/^(\d+)\.\s+/);
    const from = numbered ? numbered[0].length : 0;
    const end = rest.slice(from).search(/[.:]\s/);
    if (end !== -1) {
      const cut = from + end + 1;
      heading = rest.slice(0, cut);
      body = rest.slice(cut).trim();
    }

    out.push(`${level} ${heading.trim()}`, '');

    if (body) {
      if (/^1\.\s/.test(body)) {
        body
          .split(/(?=\b\d+\.\s)/)
          .map((s) => s.trim())
          .filter(Boolean)
          .forEach((item) => out.push(item, ''));
      } else {
        out.push(body, '');
      }
    }
  }

  return out.join('\n').replace(/\n{3,}/g, '\n\n').trim();
}